var _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCryptoCom(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 30 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 0L0 8.662v17.324l15 8.662 15-8.662V8.662L15 0zm13.683 25.228L15 33.132 1.317 25.228V9.432L15 1.53l13.683 7.903v15.796z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.878 7.481H9.084l-1.367 6.015h14.578l-1.417-6.015zM11.185 21.76v-3.989l-3.492-2.224L3.74 18.48l5.38 9.37h2.15l2.548-2.361v-1.193l-2.634-2.535z",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.828 14.403h-7.63l1.28 3.356-.386 3.753H15l2.933-.012-.36-3.741 1.255-3.356z",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.32 15.522l-3.455 2.25v3.989l-2.634 2.535v1.193l2.535 2.336h2.125l5.369-9.345-3.94-2.958z",
    fill: "#fff"
  })));
}

export default SvgCryptoCom;